import React, { useState, useContext } from 'react'
import { FirebaseContext } from '../../Services/firebase'

import { 
    Button, 
    TextField, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle, 
    Alert 
  } from '@mui/material';

export default function ForgetPassword() {

    const firebase = useContext(FirebaseContext)

    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const handleSubmit = () => {
        firebase.passwordReset(email)
        .then(() => {
            setError(null);
            setSuccess(`email envoyé avec succès à l'adresse ${email}`)
            setEmail('')
            setTimeout(() => {
                window.location.href = '/'
            }, 5000)
        })
        .catch((error) => {
            setError(error);
            setEmail('');
        })
    }

    const disabled = email === '';

    return (
        <div>
            <Button variant="text" onClick={handleClickOpen} style={{marginTop: "1vh", fontSize: "1vh"}} >
                mot de passe oublié
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Mot de passe oublié</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Entrez votre adresse email pour recevoir les instructions de réinitialisation de mot de passe.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Adresse e-mail"
                        type="email"
                        fullWidth
                        variant="standard"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </DialogContent>
                { success && <Alert severity="success">{success}</Alert> }
                { error && <Alert severity="error">{error.message}</Alert> }
                <DialogActions>
                    <Button onClick={handleClose}>Fermer</Button>
                    <Button disabled={disabled} onClick={handleSubmit}>Confirmer</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}